import React from 'react';
import { Box, Typography, Skeleton, Stack, Tooltip } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import Input from '@mui/material/Input';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import Main from '../../Main/Main';
import StarIcon from '../../../assets/img/icon-star-favorito.svg';
import './styles.scss';
import useFavoritosHook from './useFavoritosHook';
import { encodeBase64UrlSafe } from '../../Utils/utils';

export default function Favoritos({ escopoAcesso, setEscopoAcesso }) {
  const {
    filtrar,
    handleOnChangePesquisar,
    filtro,
    handleKeyDown,
    listaDeFavoritos,
    isPendingMenu,
    handleToggleFavorito,
    handleTogglePin,
    qtdFixados
  } = useFavoritosHook(setEscopoAcesso);

  return (
    <Main
      title="Favoritos"
      className="tela-favoritos"
      escopoAcesso={escopoAcesso}
      setEscopoAcesso={setEscopoAcesso}
    >
      <Box className="container-favoritos">
        <Box className="content-favoritos">
          <Typography className="titulo-favoritos" variant="h2">
            Seus favoritos
          </Typography>
          <Typography className="msg-fixar-favoritos">
            Destaque até 3 páginas favoritas na sua tela inicial com o ícone
            <PushPinOutlinedIcon className="icon-fixado" alt="Fixado" />.
          </Typography>
          <Input
            className="input-pesquisa"
            type="text"
            placeholder="Pesquisar por nome da página"
            value={filtro}
            disableUnderline
            autoFocus={false}
            onChange={handleOnChangePesquisar}
            onKeyDown={handleKeyDown}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={() => filtrar(filtro)}
                  onMouseDown={e => e.preventDefault()}
                  onMouseUp={e => e.preventDefault()}
                >
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </Box>

        <Grid container spacing={2} className="main-favoritos">
          {isPendingMenu ? (
            <Grid item xs={12}>
              <Box className="loader-container">
                <Stack className="skeleton" spacing={1}>
                  {[...Array(3)].map((_, index) => (
                    <React.Fragment key={index}>
                      <Skeleton variant="text" width="100%" height={50} />
                      <Skeleton variant="rectangular" width="100%" height={50} />
                    </React.Fragment>
                  ))}
                </Stack>
              </Box>
            </Grid>
          ) : listaDeFavoritos.length > 0 ? (
            listaDeFavoritos.map((favorito, idx) => (
              <Grid item key={idx} xs={12} sm={6} md={4} lg={3}>
                <Link
                  to={`/iframe/${encodeBase64UrlSafe(favorito.CODDEPARTAMENTO)}/${encodeBase64UrlSafe(favorito.CODSUBMENU)}`}
                  className="color-unset text-decoration-unset flex-box pad-15 w-100"
                >
                  <Box className="card-container">
                    <Box className="card-icones">
                      <Grid container>
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={3}
                          lg={3}
                          className="texto-centro padding-icones"
                          onClick={e => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleTogglePin(favorito);
                          }}
                        >
                          <Tooltip
                            placement="right"
                            title={
                              favorito.FIXADO === 'S'
                                ? 'Desfixar da página inicial'
                                : qtdFixados >= 3
                                  ? 'Limite de 3 páginas fixadas atingido'
                                  : 'Fixar na página inicial'
                            }
                          >
                            <Box
                              className={`icone-fixado ${favorito.FIXADO === 'S' ? 'cor-fixado' : ''} ${qtdFixados >= 3 ? 'pin-icon-disabled' : ''}`}
                            >
                              {favorito?.FIXADO === 'S' ? (
                                <PushPinIcon alt="Fixado" className="pin-icon-fixed" />
                              ) : (
                                <PushPinOutlinedIcon alt="Não fixado" className="pin-icon" />
                              )}
                            </Box>
                          </Tooltip>
                        </Grid>

                        <Grid item xs={7} sm={7} md={7} lg={7} />

                        <Grid
                          item
                          xs={2}
                          sm={2}
                          md={2}
                          lg={2}
                          className="texto-centro padding-icones"
                          onClick={e => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleToggleFavorito(favorito);
                          }}
                        >
                          <Tooltip title="Remover dos favoritos">
                            <Box
                              component="img"
                              src={StarIcon}
                              alt="Favorito"
                              className="star-icon hover-icons"
                            />
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </Box>
                    <Box className="card-content">
                      <strong>{favorito.SUBMENU}</strong>
                      <p>{favorito.NOMEDEPARTAMENTO}</p>
                    </Box>
                  </Box>
                </Link>
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Box className="sem-registro">
                {filtro && (
                  <h3 className="nenhum-resultado-encontrado">{`Nenhum favorito encontrado com o filtro "${filtro}".`}</h3>
                )}

                {!filtro && (
                  <>
                    <h2>Nenhum favorito por aqui ainda!</h2>
                    <p>
                      Marque suas páginas mais acessadas como favoritas e acesse por aqui sempre que
                      precisar.
                    </p>
                  </>
                )}
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
    </Main>
  );
}
